import React from 'react';

const ProjectPage = () => {
    return (
        <div>This is the Project Page!</div>
    )
}

export default ProjectPage;